import type { UserAnalyticsDto } from "@superblocksteam/shared";

import { callServer, HttpMethod } from "../../utils/client";

export async function getAnalytics() {
  const data = await callServer<UserAnalyticsDto>(
    {
      method: HttpMethod.Get,
      url: "v1/users/analytics",
    },
    {
      // hide because this path is non critical and we don't want to show error to user (especially in embed mode)
      notifyOnError: false,
    },
  );
  handleDates(data);
  return data;
}

function isIsoDateString(value: unknown): value is string {
  const isoDateFormat =
    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?(?:[-+]\d{2}:?\d{2}|Z)?$/;
  return !!value && typeof value === "string" && isoDateFormat.test(value);
}

function handleDates(body: any) {
  if (body === null || body === undefined || typeof body !== "object")
    return body;

  for (const key of Object.keys(body)) {
    const value = body[key];
    if (isIsoDateString(value)) {
      body[key] = new Date(value);
    } else if (typeof value === "object") {
      handleDates(value);
    }
  }
}
